import React from "react";
import ErrorSomethingWrong from "../../pages/error/ErrorSomethingWrong";
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.log(error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // no we only use these boundaries on top level, we can return the 404
      return <ErrorSomethingWrong></ErrorSomethingWrong>;
    }

    return this.props.children;
  }
}
